import { IBeneficiary } from '../../src/components';
import { IAgentAccount, IAgentAccountParam, IAgentManageInfo } from '../../types/app-account/agent';
import { IUpdateAgentPasswordParam, IUpdateAgentPhoneParam } from '../../types/app-account/enterprise';
import { IAgentMergeInfo, IBusinessAuthInfo, IUpdateBusinessAuth } from '../../types/common';
import { IAgentUser } from '../../types/user-center/agent';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 账户中心 - 代理商管理数据查询
 */
export async function queryAgentAccounts(param: IAgentAccountParam) {
  let data = [] as IAgentAccount[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IAgentAccountParam;

  try {
    const { code, context, message } = await Http.post<{ data: IAgentAccount[]; total: number }>(`${hostUrl}/side/agent/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IAgentAccount[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 账户中心 - 代理商管理 - 启用、停用
 */
export async function changeAccAgentStatus(id: number) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/agent/changeEnable`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
/**
 * 账户中心 - 代理商管理 - 导出
 */

export async function exportAgentManage(params: IAgentAccountParam) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/side/agent/export`,
      params,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 账户中心 - 受益人信息列表
 * @param type true 代理商 false 企业
 */
export async function queryAccountUboList(type: boolean, id: number) {
  let data = [] as IBeneficiary[];

  const typeStr = type ? 'agentUbo' : 'companyUbo';

  try {
    const { code, context, message } = await Http.post<IBeneficiary[]>(`${hostUrl}/side/${typeStr}/list`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IBeneficiary[];

      data = items || [] as IBeneficiary[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 账户中心 - 企业管理 详情 - 受益人信息保存
 * @param type true 代理商 false 企业
 */
export async function saveAccountUboList(type: boolean, id: number, beneficiary: IBeneficiary[]) {
  const params = type
    ? {
      agentId: id,
      agentUboList: beneficiary,
    }
    : {
      companyId: id,
      companyUboList: beneficiary,
    };

  const typeStr = type ? 'agentUbo' : 'companyUbo';

  try {
    const { code, message } = await Http.post<IBeneficiary[]>(`${hostUrl}/side/${typeStr}/insert`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 代理商管理 个人代理商 新增、编辑
 * @param type false: 新增  true: 修改
 */
export async function insertAccountAgentPerson(param: IAgentManageInfo, type: boolean) {

  param = JSON.parse(JSON.stringify(param)) as IAgentManageInfo;

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/side/agent/${!type ? 'insert' : 'update'}Person`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 账户中心 - 代理商管理 企业代理商 新增、编辑
 * @param type false: 新增  true: 修改
 */
export async function insertAccountAgent(param: IAgentMergeInfo, type: boolean) {

  param = JSON.parse(JSON.stringify(param)) as IAgentMergeInfo;

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/side/agent/${!type ? 'insert' : 'update'}`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 账户中心 - 代理商管理 获取修改权限数据
 */
export async function queryBusinessAgent(agentId: number) {
  let data = [] as IBusinessAuthInfo[];

  try {
    const { code, context, message } = await Http.get<IBusinessAuthInfo[]>(`${hostUrl}/iam/business/agent`, { agentId });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [] as IBusinessAuthInfo[];

      data = res || [] as IBusinessAuthInfo[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 账户中心 - 代理商管理 修改权限数据
 */
export async function updateBuinessAgent(params: {agentId: number; businessList: IBusinessAuthInfo[]}) {
  params = JSON.parse(JSON.stringify(params)) as {agentId: number; businessList: IBusinessAuthInfo[]};

  try {
    const { code, message } = await Http.put<{agentId: number; businessList: IBusinessAuthInfo[]}>(`${hostUrl}/iam/business/agent`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 代理商管理 批量修改权限数据
 */
export async function updateBuinessAgents(params: IUpdateBusinessAuth) {
  params = JSON.parse(JSON.stringify(params)) as IUpdateBusinessAuth;

  try {
    const { code, message } = await Http.put<IUpdateBusinessAuth>(`${hostUrl}/iam/business/agents`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 代理商安全 - 修改密码
 */
export async function updateAgentPassword(params: IUpdateAgentPasswordParam) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/agentPay/updatePassword`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 代理商安全  - 修改手机号
 */
export async function updateAgentPhone(params: IUpdateAgentPhoneParam) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/agentPay/updatePhone`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 代理商安全  详情 - 修改手机号（无验证码版）
 */
export async function updateCurAgentPhone(agentId: number, newPhone: string) {
  try {
    const { code, message } = await Http.post<{agentId: number; newPhone: string}>(`${hostUrl}/side/agentPay/updatePhone/noCode`, {
      agentId,
      newPhone,
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 代理商安全  详情 - 重置密码（无验证码版）
 */
export async function resetCurAgentPhone(agentId: number) {
  try {
    const { code, message } = await Http.post<{agentId: string }>(`${hostUrl}/side/agentPay/resetPassword/noCode`, { agentId });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 账户中心 - 代理商管理 - 代理商用户列表
 */
export async function queryAgentUserList(id: number) {
  let data = [] as IAgentUser[];

  try {
    const { code, context, message } = await Http.post<Array<IAgentUser>>(`${hostUrl}/side/agent/userList`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 账户中心 - 代理商管理 - 查询代理商自身拥有的业务权限
 */
export async function queryAgentBusinessList(agentId: number) {
  let data = [] as IBusinessAuthInfo[];

  try {
    const { code, context, message } = await Http.get<Array<IBusinessAuthInfo>>(`${hostUrl}/iam/business/agent-self`, { agentId });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}
